
import * as React from 'react';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Typography } from '@mui/material';

interface AurCenteredTabsProps {
  defaultValue?: number;
  tabsArray: string[];
  onTabSelection?: (selectedTab: number) => void;
}

const AurCenteredTabs: React.FC<AurCenteredTabsProps> = ({
  defaultValue = 0,
  tabsArray,
  onTabSelection,
}) => {
  const [value, setValue] = React.useState(defaultValue);

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    if (onTabSelection) {
      onTabSelection(newValue);
    }
  };

  const displayTabName = (label: string) => {
    return (
      <Typography className='typo-text buttonSmall_size lowercase'>{label}</Typography>
    )
  }

  return (
    <Box className='aur-centered-tabs'>
      <Box className='aur-centered-tabs-horizontal-line' />

      {/* Tabs */}
      <Tabs
        value={value}
        onChange={handleChange}
        centered
        TabIndicatorProps={{
          sx: {
            display: 'none',
          },
        }}
        className='aur-centered-tabs-main'
      >
        {tabsArray.map((tabLabel, index) => (
          <Tab
            key={index + 1}
            label={displayTabName(tabLabel)}
            className='aur-centered-tabs-content'
          />
        ))}
      </Tabs>
      <Box className='aur-centered-tabs-horizontal-line' />
    </Box>
  );
};

export default AurCenteredTabs;
